module.exports = __webpack_public_path__ + "static/media/fastway.6179caa0.svg";